import { TenantDto, TenantRequestDto, TenantRequestStage } from "@/core/api/generated/v1";

export class TenantRequestHelper {
  public static canBeEdited(tenantRequest: TenantRequestDto | null | undefined): boolean {
    return tenantRequest?.stageHistory?.stage === TenantRequestStage.Draft;
  }

  public static canBeDeleted(tenantRequest: TenantRequestDto | null | undefined): boolean {
    return (
      tenantRequest?.stageHistory?.stage === TenantRequestStage.Draft ||
      tenantRequest?.stageHistory?.stage === TenantRequestStage.Declined ||
      tenantRequest?.stageHistory?.stage === TenantRequestStage.Returned
    );
  }

  public static isSentByMe(
    currentTenant: TenantDto | null | undefined,
    tenantRequest: TenantRequestDto | null | undefined,
  ): boolean {
    return (
      !!currentTenant && !!tenantRequest && currentTenant.id === tenantRequest.senderTenant?.id
    );
  }

  public static isReceivedByMe(
    currentTenant: TenantDto | null | undefined,
    tenantRequest: TenantRequestDto | null | undefined,
  ): boolean {
    return (
      !!currentTenant && !!tenantRequest && currentTenant.id === tenantRequest.receiverTenant?.id
    );
  }

  public static isSentOrReceivedByMe(
    currentTenant: TenantDto | null | undefined,
    tenantRequest: TenantRequestDto | null | undefined,
  ): boolean {
    return (
      this.isSentByMe(currentTenant, tenantRequest) ||
      this.isReceivedByMe(currentTenant, tenantRequest)
    );
  }
}
